import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, FacebookIcon, TwitterIcon, InstagramIcon, CheckCircleIcon, ShieldCheckIcon, PoundSterlingIcon, LockIcon } from 'lucide-react';
export function Footer() {
  const trustBadges = [{
    icon: CheckCircleIcon,
    text: 'UK-based'
  }, {
    icon: ShieldCheckIcon,
    text: 'Vetted Engineers'
  }, {
    icon: PoundSterlingIcon,
    text: 'Clear Pricing'
  }, {
    icon: LockIcon,
    text: 'Secure Payments'
  }];
  return <footer className="bg-slate-800 text-white" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-29">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-30">
          <div data-id="element-31">
            <div className="mb-4" data-id="element-32">
              <Logo data-id="element-33" />
            </div>
            <p className="text-slate-300 text-sm mb-4" data-id="element-34">
              Professional appliance repairs and maintenance across the UK.
            </p>
            <div className="flex gap-3" data-id="element-35">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-slate-700 p-2 rounded-lg hover:bg-teal-600 transition" aria-label="Facebook" data-id="element-36">
                <FacebookIcon className="w-5 h-5" data-id="element-37" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-slate-700 p-2 rounded-lg hover:bg-teal-600 transition" aria-label="Twitter" data-id="element-38">
                <TwitterIcon className="w-5 h-5" data-id="element-39" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-slate-700 p-2 rounded-lg hover:bg-teal-600 transition" aria-label="Instagram" data-id="element-40">
                <InstagramIcon className="w-5 h-5" data-id="element-41" />
              </a>
            </div>
          </div>
          <div data-id="element-42">
            <h3 className="font-semibold text-lg mb-4" data-id="element-43">Quick Links</h3>
            <ul className="space-y-2 text-slate-300 text-sm" data-id="element-44">
              <li data-id="element-45">
                <Link to="/" className="hover:text-teal-400 transition" data-id="element-46">
                  Home
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/services" className="hover:text-teal-400 transition" data-id="element-48">
                  Repair Service Details
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/about" className="hover:text-teal-400 transition" data-id="element-50">
                  About Us
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/faq" className="hover:text-teal-400 transition" data-id="element-52">
                  FAQs
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/contact" className="hover:text-teal-400 transition" data-id="element-54">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-55">
            <h3 className="font-semibold text-lg mb-4" data-id="element-56">Policies</h3>
            <ul className="space-y-2 text-slate-300 text-sm" data-id="element-57">
              <li data-id="element-58">
                <Link to="/terms-of-service" className="hover:text-teal-400 transition" data-id="element-59">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/cancellation" className="hover:text-teal-400 transition" data-id="element-61">
                  Cancellation
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/refund" className="hover:text-teal-400 transition" data-id="element-63">
                  Refund
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/privacy-policy" className="hover:text-teal-400 transition" data-id="element-65">
                  Privacy & Cookies
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-66">
            <h3 className="font-semibold text-lg mb-4" data-id="element-67">Contact Us</h3>
            <ul className="space-y-3 text-slate-300 text-sm" data-id="element-68">
              <li className="flex items-start gap-2" data-id="element-69">
                <MapPinIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-70" />
                <span data-id="element-71">5 London Rd, Portsmouth PO2 0BQ</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-72">
                <PhoneIcon className="w-4 h-4 flex-shrink-0" data-id="element-73" />
                <a href="tel:08000554969" className="hover:text-teal-400 transition" data-id="element-74">
                  0800 055 4969
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-75">
                <MailIcon className="w-4 h-4 flex-shrink-0" data-id="element-76" />
                <a href="mailto:Sumittandon092@gmail.com" className="hover:text-teal-400 transition break-all" data-id="element-77">
                  Sumittandon092@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2" data-id="element-78">
                <ClockIcon className="w-4 h-4 mt-1 flex-shrink-0" data-id="element-79" />
                <div data-id="element-80">
                  <p data-id="element-81">Mon-Fri: 9:00-17:00</p>
                  <p data-id="element-82">Sat-Sun: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mb-8" data-id="element-83">
          <h3 className="font-semibold text-lg mb-4 text-center" data-id="element-84">
            Why Choose Us
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-85">
            {trustBadges.map((badge, index) => <div key={index} className="flex items-center gap-2 justify-center bg-slate-700 rounded-lg p-3" data-id="element-86">
                <badge.icon className="w-5 h-5 text-teal-400" data-id="element-87" />
                <span className="text-sm font-medium" data-id="element-88">{badge.text}</span>
              </div>)}
          </div>
        </div>
        <div className="relative h-48 rounded-lg overflow-hidden mb-8" data-id="element-89">
          <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?w=1200&h=400&fit=crop" alt="Happy family in modern kitchen with repaired appliances" className="w-full h-full object-cover" data-id="element-90" />
        </div>
        <div className="border-t border-slate-700 pt-8 text-center text-slate-400 text-sm" data-id="element-91">
          <p data-id="element-92">
            &copy; {new Date().getFullYear()} Brighthands. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}